// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__Zr8P-","icon":"SortAdornment_icon__3w4NG","up":"SortAdornment_up__35iFu","down":"SortAdornment_down__1mgqa","active":"SortAdornment_active__cHBMm"};